/**
 * Stories Domain Enums — standalone (no GraphQL dependency)
 *
 * These enums were extracted from graphql/generated.ts so that
 * other contexts can import them without pulling in the full
 * GraphQL codegen output.
 */

// Language lives in shared/types/audio.ts to break circular dep with audio-stories
export { Language } from '@/shared/types/audio';

export enum AgeGroup {
  Age_1_3 = 'AGE_1_3',
  Age_3_5 = 'AGE_3_5',
  Age_5_7 = 'AGE_5_7',
  Age_7_10 = 'AGE_7_10',
  Age_10Plus = 'AGE_10_PLUS',
}

export enum StoryType {
  Adventure = 'adventure',
  Bedtime = 'bedtime',
  Classic = 'classic',
  Comedy = 'comedy',
  Educational = 'educational',
  Everyday = 'everyday',
  Fable = 'fable',
  Funny = 'funny',
  Lullaby = 'lullaby',
  Mystery = 'mystery',
  Serious = 'serious',
  /**
   * A real year, told as a story (the New Year campaign). Not offered in the
   * wizard's genre picker: it is what the questionnaire orders, and its plot
   * comes from the answers rather than from a theme
   * (`STORY_TYPE_DIRECTIVES.year_recap`).
   */
  YearRecap = 'year_recap',
}

export enum StoryStatus {
  Assembling = 'assembling',
  AudioCompleted = 'audio_completed',
  Completed = 'completed',
  Draft = 'draft',
  Error = 'error',
  GeneratingAudio = 'generating_audio',
  GeneratingText = 'generating_text',
  ReadyForAudio = 'ready_for_audio',
  TextCompleted = 'text_completed',
  TextEdited = 'text_edited',
}

export enum BlockStatus {
  Edited = 'edited',
  Original = 'original',
  Regenerated = 'regenerated',
}

export enum VoiceGender {
  Female = 'FEMALE',
  Male = 'MALE',
}

export enum StoryJobStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing',
}

export enum StoryJobType {
  TextGeneration = 'text_generation',
}

export enum CharacterRole {
  Friend = 'friend',
  Helper = 'helper',
  Hero = 'hero',
  Obstacle = 'obstacle',
}

export enum CharacterGender {
  Female = 'female',
  Male = 'male',
  Neutral = 'neutral',
}

export enum CharacterCreationMethod {
  AiEnhanced = 'ai_enhanced',
  AiGenerated = 'ai_generated',
  Manual = 'manual',
}

export enum CharacterImportance {
  Main = 'main',
  Minor = 'minor',
  Supporting = 'supporting',
}
